import Aegis, {
  getHostUrlForDos,
  retCodeHandlerForS2,
} from '@tencent/jmonitor-web-sdk';

export const aegis = new Aegis({
  hostUrl: getHostUrlForDos(),
  id: 'DEFAULT', // TODO: 联系shuchen分配一个appid
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 页面需要开启，页面切换的时候上报pv
  api: {
    retCodeHandler: retCodeHandlerForS2,
  },
});

console.log(`create aegis version: ${Aegis.version}`);

// /**
//  * 上报错误日志
//  */
// export const logError: Aegis['error'] = (...args) => aegis.error(...args);

// /**
//  * 上报自定义日志
//  */
// export const logInfo: Aegis['infoAll'] = (...args) => aegis.infoAll(...args);
